export enum EntityFilterType {
  NoFilter,
  Singleton,
  All,
  AllWithNoProject,
  AllWithSingletonProject
}
